import React from "react";
import { View, StyleSheet, Text } from "@react-pdf/renderer";
import { config } from "./config";

const styles = StyleSheet.create({
  table: {
    width: "100%",
  },
  tableSubtask: {
    width: "30%",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#585e66",
    color: "#fff",
    padding: 3,
  },
  headerCell: {
    fontWeight: "heavy",
    white: "#fff",
    width: "11.11%",
    fontSize: config.normalFontSize,
  },
  body: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f5f5f5",
  },
  cell: {
    width: "11.11%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "5px 3px",
  },
});

const TableSubtask = ({ children }) => (
  <View style={styles.tableSubtask}>{children}</View>
);

const Table = ({ children }) => <View style={styles.table}>{children}</View>;

const TableHeader = ({ children }) => (
  <View style={styles.header}>{children}</View>
);

const TableHeaderCell = ({ children }) => (
  <Text style={styles.headerCell}>{children}</Text>
);

const TableBody = ({ children }) => <View style={styles.body}>{children}</View>;

const TableRow = ({ children }) => <View style={styles.row}>{children}</View>;

const TableCell = ({ children }) => <Text style={styles.cell}>{children}</Text>;

Table.Header = TableHeader;
Table.Body = TableBody;
Table.Row = TableRow;
Table.HeaderCell = TableHeaderCell;
Table.Cell = TableCell;
Table.Subtask = TableSubtask;

export default Table;
